import React, { useState } from "react";
import { Menu } from "../components/menu";
import { SmallFooter } from "../components/smallFooter";
import { SectionLive } from "../lives/components/sectionLive";
import { SectionCurrentSchedule } from "../lives/components/sectionCurrentSchedule";
import { schedule } from "../lives/schedule";
import styled from "styled-components";
import SectionNextWeek from "../lives/components/sectionNextWeek";
import { SectionBlack } from "../lives/components/sectionBlack";
import RenderModal from "../components/renderModal";
import ModalLead from "../components/ModalLead";
import Ended from "../lives/components/sectionLive/ended";

const Lives = () => {

    const [toggleModal, setToggleModal] = useState(false);

    //"2023-10-30T20:31:00-03:00"
    const currentTime = new Date();

    let currentWeek;
    if (currentTime < new Date(schedule[0].endDate)) {
        currentWeek = schedule[0];
    } else {
        currentWeek = schedule[1];
    }

    const currentFormatedDate = `${currentTime.getDate()}/${currentTime.getMonth() + 1}`;
    let currentDayIndex;
    switch (currentFormatedDate) {
        case "30/10":
            currentDayIndex = 0;
            break;
        case "31/10":
            currentDayIndex = 1;
            break;
        case "1/11":
            currentDayIndex = 2;
            break;
        case "2/11":
            currentDayIndex = 3;
            break;
        case "3/11":
            currentDayIndex = 4;
            break;
        case "4/11":
            currentDayIndex = 5;
            break;
        case "5/11":
            currentDayIndex = 6;
            break;
        case "6/11":
            currentDayIndex = 0;
            break;
        case "7/11":
            currentDayIndex = 1;
            break;
        case "8/11":
            currentDayIndex = 2;
            break;
        case "9/11":
            currentDayIndex = 3;
            break;
        case "10/11":
            currentDayIndex = 4;
            break;
        case "11/11":
            currentDayIndex = 5;
            break;
        case "12/11":
            currentDayIndex = 6;
            break;
        default:
            currentDayIndex = 0;
            break;
    }

    let currentClassIndex;
    for (let i = 0; i < currentWeek.days[currentDayIndex].classes.length; i++) {
        const classTime = new Date(currentWeek.days[currentDayIndex].classes[i].hour);
        if (currentTime >= classTime) {
            currentClassIndex = i;
        }
        if (currentTime < new Date(currentWeek.days[currentDayIndex].classes[0].hour) || currentTime.getHours() > 19) {
            currentClassIndex = null;
        }
    }
    //https://storage.aprovatotal.com.br/admin-storage-prod/sos-aprova/sos_aprova_dia_1.pdf
    const handleContent = (contentType, contentUrl) => {
        const isSubscribed = localStorage.getItem("inscrito-sos-aprova-2023");
        if (!isSubscribed) {
            setToggleModal(true);
        } else {
            if (contentType === "ebook") {
                window
                    .open(
                        `https://storage.aprovatotal.com.br/platform-storage-prod/sos-aprova-2025/${contentUrl}.pdf`,
                        "_blank"
                    )
                    .focus();
            } else if (contentType === "simulated") {
                window.open(`simulado/${contentUrl}`, "_blank").focus();
            }
        }
    };

    const eventEnded = currentTime > new Date("2023-11-13T00:00:00-03:00");

    return (
        <Container>
            <Menu/>
            {
                !eventEnded ?
                    <>
                        <SectionLive currentLiveURL={currentWeek.days[currentDayIndex].liveUrl}/>
                        <SectionCurrentSchedule
                            currentTime={currentTime}
                            currentWeek={currentWeek}
                            currentDayIndex={currentDayIndex}
                            currentClassIndex={currentClassIndex}
                            handleContent={handleContent}
                        />
                    </>
                    : <Ended/>
            }
            {
                currentWeek.week === 1 ?
                    <SectionNextWeek weekSchedule={schedule[1]}/>
                    : null
            }
            <SectionBlack/>
            <SmallFooter/>
            {toggleModal && (
                <RenderModal>
                    <ModalLead toggleModal={() => setToggleModal(false)}/>
                </RenderModal>
            )}
        </Container>
    )
}

const Container = styled.div`
    background: #020052;

    height: 100%;
`;

export default Lives;

